// @ts-strict-ignore
/**
 * FX HedgePool Inc. Proprietary and Confidential
 *
 * This source code and the algorithms implemented herein are the sole property of FX HedgePool, Inc.,
 * are confidential information, and are trade secrets of FX HedgePool, Inc.
 * Redistribution or use of this source code or the algorithms implemented herein, in whole or in part,
 * without the express written permission of FX HedgePool, Inc. is strictly prohibited.
 */

import { Injectable, OnDestroy } from '@angular/core';
import { Subject, Observable } from 'rxjs';

import { LocalStorageKey } from './models';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService implements OnDestroy {
  private localStorageSub = new Subject<string>();

  public ngOnDestroy(): void {
    this.localStorageSub.unsubscribe();
  }

  public set(key: `${LocalStorageKey}`, value: string): void {
    localStorage.setItem(key, value);
    this.localStorageSub.next('added');
  }

  public get(key: `${LocalStorageKey}`): string {
    return localStorage.getItem(key);
  }

  public remove(key: `${LocalStorageKey}`): void {
    localStorage.removeItem(key);
    this.localStorageSub.next('removed');
  }

  public watchStorage(): Observable<any> {
    return this.localStorageSub.asObservable();
  }
}
